<p-confirmDialog key="parentportalpreconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="parentportalconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="parentportal" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Instructions-->
<div class="InfoDiv">
	<h4 style="text-align: center">Instructions</h4>
	<div>
		<ul>
			<li>Fill in Parents Table</li>
			<li>Add Parents/Guardians and Fill in their Emails</li>
			<li>Press Send Emails to send them a registration code</li>
			<li>Parents can then download the Parent Portal App</li>
			<li>When they open the app it will ask them to scan the QR code they received</li>
		</ul>
	</div>
</div>

<!--Parent Table-->
<div>
	<p-table
		#mydt
		[value]="lstGuardian"
		[loading]="LoadingGuardian"
		[paginator]="true"
		[(rows)]="guardianpagerows"
		[(first)]="guardianpagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<!-- <tr>
								<th>
									<p-columnFilter type="text" field="ParentName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<th>
									<p-columnFilter field="HasEmailDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterHasEmailDesc
												[ngModel]="value"
												[options]="lstHasEmailDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr> -->

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="ParentName">Name<p-sortIcon field="ParentName"></p-sortIcon></th>
				<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Guardian>
			<tr>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					<input class="form-control" [(ngModel)]="Guardian.ParentName" />
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					<input class="form-control" [(ngModel)]="Guardian.Email" />
				</td>
				<td>
					<button class="btn btn-danger" (click)="onDelete(Guardian.ID)"><i class="fa fa-times" aria-hidden="true"></i></button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAddGuardian()">Add Guardian</button>
	<button class="btn btn-success" style="margin-left: 5px" (click)="onSendEmails()">Send Emails</button>
</div>

<div class="TopMargin">
	<div name="ErrorMessage" *ngIf="ErrorMessage" class="alert alert-danger">{{ ErrorMessage }}</div>
</div>

<!--Registered Parents-->
<div class="InfoDiv TopMargin">
	<h4 style="text-align: center; margin: 0px">Currently Registered Parents</h4>
</div>

<!--Table-->
<div>
	<p-table
		#mydt
		[value]="lstRegUser"
		[loading]="LoadingRegUser"
		[paginator]="true"
		[(rows)]="reguserpagerows"
		[(first)]="reguserpagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedRegUser"
		dataKey="RegUserID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UserID_Email-->
				<th>
					<p-columnFilter type="text" field="UserID_Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LanguageDesc-->
				<th>
					<p-columnFilter field="LanguageDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterLanguageDesc
								[ngModel]="value"
								[options]="lstLanguageDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--RegPersonActiveDesc-->
				<th>
					<p-columnFilter field="RegPersonActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterRegPersonActiveDesc
								[ngModel]="value"
								[options]="lstRegPersonActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="UserID_Email">Email<p-sortIcon field="UserID_Email"></p-sortIcon></th>
				<th pSortableColumn="LanguageDesc">Language<p-sortIcon field="LanguageDesc"></p-sortIcon></th>
				<th pSortableColumn="RegPersonActiveDesc">Assigned to Student<p-sortIcon field="RegPersonActiveDesc"></p-sortIcon></th>
				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-RegUser>
			<tr [pSelectableRow]="RegUser">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ RegUser.FirstName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ RegUser.LastName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ RegUser.UserID_Email }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ RegUser.LanguageDesc }}
				</td>
				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="RegUser.RegPersonActive == true ? 'Black' : 'Red'"
				>
					{{ RegUser.RegPersonActive == true ? "Assigned" : "Removed" }}
				</td>
				<td>
					<button *ngIf="RegUser.RegPersonActive == true" class="btn btn-danger" (click)="onUpdateRegPerson(RegUser, 0)">Remove Guardian</button>
					<button *ngIf="RegUser.RegPersonActive == false" class="btn btn-success" (click)="onUpdateRegPerson(RegUser, 1)">
						Re-Activate Guardian
					</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
